module.exports = __webpack_public_path__ + "img/pix.07300efa.svg";